import React from 'react';
import { SEO } from '../../components/seo/seo';
import { appReviews, premiumProFaqs } from './pro_page_data';

export const ProPageSEO = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Product',
        name: 'Omnia PRO',
        description:
          'Join Omnia PRO to access advanced fishing maps, expert insights, and live habitat updates. Enjoy FREE shipping and 10% back on purchases. Sign up for $59/year.',
        url: 'https://www.omniafishing.com/',
        brand: {
          '@type': 'Organization',
          name: 'Omnia Fishing',
          url: 'https://www.omniafishing.com',
        },
        category: 'Subscription',
        offers: {
          '@type': 'Offer',
          price: '49.99',
          priceCurrency: 'USD',
          url: 'https://www.omniafishing.com/pro',
          availability: 'https://schema.org/InStock',
          eligibleRegion: {
            '@type': 'Country',
            name: 'USA',
          },
          seller: {
            '@type': 'Organization',
            name: 'Omnia Fishing',
          },
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.7',
          reviewCount: '1100',
        },
        creator: {
          '@type': 'Organization',
          name: 'Omnia Fishing',
          url: 'https://www.omniafishing.com/',
        },
        mainEntityOfPage: 'https://www.omniafishing.com/',
        featureList: 'https://www.omniafishing.com/pro',
        additionalType: 'https://schema.org/SoftwareApplication',
        applicationSubCategory: 'FishingApplication, MappingApplication',
        applicationCategory: [
          'https://schema.org/WebApplication',
          'https://schema.org/MobileApplication',
        ],
        operatingSystem: ['All', 'iOS', 'Android'],
        review: appReviews.map((review) => ({
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: review.userName,
          },
          reviewBody: review.content,
          reviewRating: {
            '@type': 'Rating',
            ratingValue: review.rating,
            bestRating: '5',
            worstRating: '1',
          },
        })),
        additionalProperty: [
          {
            '@type': 'PropertyValue',
            name: 'Free Shipping',
            value: 'Pro members get free shipping on all orders',
          },
          {
            '@type': 'PropertyValue',
            name: '10% cash back',
            value: 'Pro members get 10% back on all purchases',
          },
          {
            '@type': 'PropertyValue',
            name: 'Discounts',
            value: 'Exclusive private sales for PRO members only',
          },
          {
            '@type': 'PropertyValue',
            name: 'Giveaways',
            value: 'Members only giveaways',
          },
        ],
      },

      {
        '@type': 'FAQPage',
        mainEntity: premiumProFaqs.map((faq) => ({
          '@type': 'Question',
          name: faq.q,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.a,
          },
        })),
      },
    ],
  };

  return (
    <SEO
      title="Omnia PRO - Advanced Fishing Maps & Tools for Serious Anglers | Omnia Fishing"
      description="Join Omnia PRO to access advanced fishing maps, expert insights, and live habitat updates. Enjoy FREE shipping and 10% back on purchases. Sign up for $59/year."
      schema={schema}
    />
  );
};
